import { render, staticRenderFns } from "./VersionDisplay.vue?vue&type=template&id=43fa8f90&"
import script from "./VersionDisplay.vue?vue&type=script&lang=js&"
export * from "./VersionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports